import { applyI18n } from '../i18n';

export type SignedOutPageOptions = {
  showSignIn?: boolean;
};

export function SignedOutPage(options?: SignedOutPageOptions): HTMLElement {
  const panel = document.createElement('div');
  panel.className = 'center-panel';
  panel.innerHTML = `
    <h1 data-i18n="auth.signedOut.title"></h1>
    <p class="muted" data-i18n="auth.signedOut.subtitle"></p>
  `;

  if (options?.showSignIn) {
    if (import.meta.env.DEV) {
      const link = document.createElement('a');
      link.href = '/login';
      link.className = 'button primary';
      link.innerHTML = `<span data-i18n="auth.login"></span>`;
      panel.appendChild(link);
    } else {
      const link = document.createElement('a');
      link.href = `/api/auth/saml/login?returnUrl=${encodeURIComponent('/')}`;
      link.className = 'button primary';
      link.innerHTML = `<span data-i18n="auth.login"></span>`;
      // Full navigation — SPA click interceptor must not swallow /api auth links.
      link.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        window.location.assign(link.href);
      });
      panel.appendChild(link);
    }
  }

  applyI18n(panel);
  return panel;
}
